import request from '../utils/request';

const BASE_URL = '/buying-post';

const buyingPostApi = {
  // 分页查询求购帖
  pageBuyingPosts(params = {}) {
    const {
      page = 1, 
      pageSize = 10, 
      sortField = 'create_time', 
      sortOrder = 'desc',
      ...queryParams
    } = params;

    return request.post(`${BASE_URL}/page`, {
      page,
      pageSize,
      sortField,
      sortOrder,
      ...queryParams
    });
  },

  // 获取求购帖详情
  getBuyingPostDetail(id) {
    return request.get(`${BASE_URL}/${id}`);
  },

  // 审核求购帖
  auditBuyingPost(id, auditData) {
    return request.put(`${BASE_URL}/audit/${id}`, auditData);
  },

  // 删除求购帖
  deleteBuyingPost(id) {
    return request.delete(`${BASE_URL}/${id}`);
  },

  // 创建求购帖（管理员）
  createBuyingPost(data) {
    return request.post(BASE_URL, data);
  }
};

export default buyingPostApi;
